<template>
  <div>
    <h2 class="is-size-3">Observations</h2>
    <observation-category-list />
  </div>
</template>

<script>
import ObservationCategoryList from '@/components/observations/ObservationCategoryList'

export default {
  components: {
    ObservationCategoryList
  }
}
</script>
